import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslateService } from '@vinnova/translation';
import { map, Observable } from 'rxjs';
import { EnglishDisclaimerService } from './english-disclaimer.service';

@Component({
  selector: 'lib-english-disclaimer',
  templateUrl: './english-disclaimer.component.html',
  styleUrls: ['./english-disclaimer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EnglishDisclaimerComponent implements OnInit {
  showDisclaimer$: Observable<boolean>;

  constructor(
    private translateService: TranslateService,
    private englishDisclaimerService: EnglishDisclaimerService,
  ) {}

  ngOnInit() {
    this.showDisclaimer$ = this.translateService.langChanges$.pipe(
      map((lang) => {
        const showMessage = lang === 'en';
        this.englishDisclaimerService.setShowMessage(showMessage);
        return showMessage;
      }),
    );
  }
}
